import { createRoute, redirect } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { authedChromeRoute } from '../layouts';

const pages = () => import('./pages');
const accountComp = lazyPage(pages, 'SettingsAccountHost');
const planComp = lazyPage(pages, 'PlanHost');
const teamComp = lazyPage(pages, 'SettingsTeamHost');
const teamInviteComp = lazyPage(pages, 'SettingsTeamInviteHost');

// The `/:siteId/settings` tree carries a `siteId` but no `siteEnv`; each leaf resolves the site's
// default environment. `/settings/password` lives in auth/authed.tsx - it is the 2FA redirect
// destination.

// /$siteId/settings redirects to the account page.
const settingsIndexRoute = createRoute({
  getParentRoute: () => authedChromeRoute,
  path: '/$siteId/settings',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/settings/account', params });
  },
});

const settingsAccountRoute = createRoute({
  getParentRoute: () => authedChromeRoute,
  path: '/$siteId/settings/account',
  component: accountComp,
  staticData: { title: 'Account - Settings' },
});

const settingsPlanRoute = createRoute({
  getParentRoute: () => authedChromeRoute,
  path: '/$siteId/settings/plan',
  component: planComp,
  staticData: { title: 'Plan - Settings' },
});

const settingsTeamRoute = createRoute({
  getParentRoute: () => authedChromeRoute,
  path: '/$siteId/settings/team',
  component: teamComp,
  staticData: { title: 'Team - Settings' },
});

const settingsTeamInviteRoute = createRoute({
  getParentRoute: () => authedChromeRoute,
  path: '/$siteId/settings/team/invite',
  component: teamInviteComp,
  staticData: { title: 'Invite Team Member - Settings' },
});

/** Settings family leaves to attach under the authed layout (alongside `/settings/password`). */
export const settingsLeaves = [
  settingsIndexRoute,
  settingsAccountRoute,
  settingsPlanRoute,
  settingsTeamRoute,
  settingsTeamInviteRoute,
];
